import { render, staticRenderFns } from "./CourseBuilderTextBlock.vue?vue&type=template&id=c385eeb8&scoped=true&"
import script from "./CourseBuilderTextBlock.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c385eeb8",
  null
  
)

export default component.exports